import { Component, OnInit } from '@angular/core';
import { WidgetService } from '../../../widgets/widget.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Widget, WidgetStatus, WidgetSunstudy, WidgetTemplate } from '../../../models/widget';
import { SunstudioModalComponent } from '../../../widgets/sunstudio-modal/sunstudio-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WidgetMapService } from '../../../widgets/widget-map.service';

@Component({
  selector: 'cw-project-detail-widget-detail',
  templateUrl: './project-detail-widget-detail.component.html',
  styleUrls: ['./project-detail-widget-detail.component.scss']
})
export class ProjectDetailWidgetDetailComponent implements OnInit {
  widget: Widget;
  widgetTemplateId: number;
  availableTemplates: WidgetTemplate[];

  constructor(private widgetService: WidgetService,
              private mapService: WidgetMapService,
              private route: ActivatedRoute,
              private modal: NgbModal) {
  }

  ngOnInit() {
    this.route.params
      .switchMap((params: Params) => this.widgetService.getWidget(+params['id']))
      .subscribe((widget: Widget) => {
        this.widget = widget;
        this.widgetTemplateId = this.widget.template.id;
        this.loadTemplates();
      });
  }

  showSunstudy(sunstudy: WidgetSunstudy) {
    const modalRef = this.modal.open(SunstudioModalComponent, { size: 'lg' });
    modalRef.componentInstance.initNew(this.widget, sunstudy);
  }

  showCreateSunstudy() {
    const modalRef = this.modal.open(SunstudioModalComponent);
    modalRef.componentInstance.initNew(this.widget);
  }

  onNameChange(name: string) {
    this.widget.name = name;
    this.widgetService.update(this.widget).subscribe(widget => {
      this.widget = widget;
    })
  }

  /*onMapNameChange(name: string, map: WidgetMap) {
    console.log(arguments);
    map.name = name;
    this.mapService.update(map, { name: name }).subscribe(map => {
      console.log(map);
    });
  }*/

  private loadTemplates() {
    return this.widgetService.getTemplatesForClient(this.widget.project.client).subscribe(templates => {
      this.availableTemplates = templates;
    })
  }

  get isDraft() {
    return this.widget.status === WidgetStatus.Draft;
  }

  get isArchived() {
    return this.widget.status === WidgetStatus.Archived;
  }

  get isPublished() {
    return this.widget.status === WidgetStatus.Published;
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/detail/project-detail-widget-detail/project-detail-widget-detail.component.ts